import __ from './i18n';
import { convertToDevUrl } from './urls';

const cdn = (relativePath) => {
  // Skip absolute urls
  if(relativePath.toLowerCase().startsWith('http')) {
    return relativePath;
  }

  if (relativePath && relativePath[0] !== "/") {
    relativePath = "/" + relativePath;
  }

  // The server tells the static files host (app.locals.config.staticBaseUrl, e.g. http://localhost:3000 in development).
  // Bundles are always built with NODE_ENV "production" (build/build-component-bundles.js), so the fallback below
  // would send local development to the production CDN
  const staticBaseUrl = window.config?.staticBaseUrl;
  if (typeof staticBaseUrl === 'string') {
    return `${staticBaseUrl}${relativePath}`;
  }

  if(process.env.NODE_ENV.startsWith('development')) {
    // return `${relativePath}`
    return convertToDevUrl(relativePath)
  } else {
    return `${__('static.domain')}${relativePath}`
  }
};

export default cdn;
